












































































































import { Vue, Component } from "vue-property-decorator";
import workService from "../../service/workService";
import { WorkTaskModel, WorkTaskEntity } from "../../model/Work";
import moment from "moment";
import * as _ from "lodash";
import { OrderEntity } from "../../model/Order";
import { BusinessType, ServiceType, categoryMap, OrderStatus } from "../../model/Base";
import roleUtils from "../../utils/roleUtils";
import { DurationTime } from "../../utils/utils";
import { List, PullRefresh, Empty } from "vant";
import { filterFeatureCodes, parseOrder } from "./orderUtils";

@Component({
  name: "myOrder",
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty,
  },
  filters: {
    showTime(value: string) {
      return value.substr(11, 5);
    },
    showConsumerName(value: string) {
      let index = value.indexOf(",");
      return index > 0 ? value.substr(0, index) + "..." : value;
    },
  },
})
export default class extends Vue {
  isContrast = true;

  showDate(value: string) {
    return moment(value).format("MM月DD日" as string);
  }
  showDateTime(value: string) {
    return moment(value).format("YYYY-MM-DD HH:mm");
  }
  get ServeTypes(): object[] {
    return [
      { label: this.$root.$t("order_orderlist_jipiao") as string, id: ServiceType.FlightService },
      { label: this.$root.$t("order_orderlist_jiudian") as string, id: ServiceType.HotelService },
      { label: this.$root.$t("order_orderlist_huoche") as string, id: ServiceType.TrainService },
      { label: this.$root.$t("order_orderlist_zuche") as string, id: ServiceType.TrafficService },
    ];
  }

  get OrderStatus(): object[] {
    return [
      { label: this.$root.$t("system.AllOrders") as string, id: "allorder" },
      { label: this.$root.$t("system.ApprovalDispose") as string, id: "waitapproval" },
      { label: this.$root.$t("system.RecentOrders") as string, id: "recenttrip" },
      { label: this.$root.$t("system.MyOrder") as string, id: "myorder" },
    ];
  }

  get filterCode() {
    return this.$route.query.filterCode;
  }

  model = {
    PageNo: 0,
    PageSize: 15,
    RecordCount: 15,
    BusinessTypes: [1797, 1789],
    ServiceTypes: [ServiceType.FlightService],
  };
  orders: OrderEntity[][] = [];
  orderMaps: { [key: string]: OrderEntity[] } = {};
  isCurrentOption: number = ServiceType.FlightService;
  loading = false;
  finished = false;
  isPullLoading = false;
  isEmptyState = false;
  // mount
  mounted() {
    if (this.filterCode) {
      this.changeStatus(this.filterCode as string);
    }
  }
  //activated
  activated() {
    this.loadWorks();
  }

  //methods
  DurationTime(ConsumerDate: string, FinishedDate: string) {
    if (FinishedDate && ConsumerDate) {
      let ticks = moment(FinishedDate).diff(ConsumerDate);
      if (ticks) {
        return DurationTime(ticks / 1000 / 60);
      }
    }
    return " - ";
  }

  filterFeatureCodes(featurecode: string, orderServiceType: number, item: any) {
    let __self = this;
    let str = filterFeatureCodes(featurecode, orderServiceType, item);
    let langArr = [
      { id: __self.$root.$t("order_orderdetails_yiwancheng"), text: "已完成" },
      { id: __self.$root.$t("order_orderdetails_yiquxiao"), text: "已取消" },
      { id: __self.$root.$t("order_orderdetails_yituihui"), text: "已退回" },
      { id: __self.$root.$t("order_orderdetails_daishenpi"), text: "待审批" },
      { id: __self.$root.$t("order_orderdetails_daichuli"), text: "待处理" },
      { id: __self.$root.$t("order_orderdetails_daiqueren"), text: "待确认" },
      { id: __self.$root.$t("order_orderdetails_tuifangchulizhong"), text: "退房处理中" },
      { id: __self.$root.$t("order_orderdetails_tuituanchulizhong"), text: "退团处理中" },
      { id: __self.$root.$t("order_orderdetails_tuipiaochulizhong"), text: "退票处理中" },
      { id: __self.$root.$t("order_orderdetails_youtuifang"), text: "有退房" },
      { id: __self.$root.$t("order_orderdetails_youtuituan"), text: "有退团" },
      { id: __self.$root.$t("order_orderdetails_youtuipiao"), text: "有退票" },
      { id: __self.$root.$t("order_orderdetails_gaiqianchulizhong"), text: "改签处理中" },
      { id: __self.$root.$t("order_orderdetails_yougaiqian"), text: "有改签" },
      { id: __self.$root.$t("order_orderdetails_quanbugaiqianzhong"), text: "全部改签中" },
      { id: __self.$root.$t("order_orderdetails_quanbutuifangzhong"), text: "全部退房中" },
      { id: __self.$root.$t("order_orderdetails_quanbutuipiaozhong"), text: "全部退票中" },
      { id: __self.$root.$t("order_orderdetails_quanbugaiqian"), text: "全部改签" },
      { id: __self.$root.$t("order_orderdetails_quanbutuifang"), text: "全部退房" },
      { id: __self.$root.$t("order_orderdetails_quanbutuipiao"), text: "全部退票" },
    ];
    _.forEach(langArr, (item: any) => {
      str = str.replace(item.text, item.id);
    });
    return str;
  }

  loadWorks() {
    let __self = this;
    let pageNo = __self.model.PageNo;
    workService.List(__self.model as any).then((json: any) => {
      this.loading = false;
      __self.isPullLoading = false;
      if (json.isSucc) {
        if (pageNo === 0) {
          this.orders = [];
          this.isEmptyState = false;
        }
        if (json.result.entities.length < 1) {
          this.finished = true;
          if (this.orders.length > 0) {
            return;
          } 
          this.orders = [];
          this.isEmptyState = true;
          return;
        } 
        handleArr(json);
      }
    });
    function handleArr(json: any) {
      __self.loading = false;
      let works = json.result!.entities!;
      __self.model.RecordCount = json.result!.recordCount!;
      let order: any = {};
      let orderWorks = _.orderBy(works, (o: OrderEntity) => o.OrderID, "desc");
      // console.log(orderWorks);
      
      let cleanOrders = _.remove(orderWorks as any, (o: WorkTaskEntity) => o.ServiceType == 1410 || o.ServiceType == 1466);
      for (var i = 0; i < orderWorks.length; i++) {
        var ent = orderWorks[i] as any;
        if (!ent || ent.TripOrder || ent.BusinessType != BusinessType.Sales) {
          continue;
        }
        ent.Products = parseOrder(ent);

        let orderInstance = ent.TripOrder || ent.TourOrder;
        if (!orderInstance) {
          for (var m = 0; m < cleanOrders.length; m++) {
            if (cleanOrders[m].UnionID == ent.UnionID && ent.UnionID && ent.UnionID != "") {
              ent.ReceiveAmount += (cleanOrders[m] as any).ReceiveAmount;
            }
          }
          orderInstance = ent;
        }
        if (!order[orderInstance.OrderID]) {
          order[orderInstance.OrderID] = [];
        }
        order[orderInstance.OrderID].push(ent);
        order[orderInstance.OrderID] = _.orderBy(order[orderInstance.OrderID], o => o.UniqueID);
      }
      if (__self.model.PageNo == 1) {
        //清空数组
        __self.orders.splice(0, __self.orders.length);
      }
      for (const key in order) {
        if (order.hasOwnProperty(key)) {
          let newOrders = order[key];
          let isNewOrder = true;
          for (let i = 0; i < __self.orders.length; i++) {
            let ctxOrders = __self.orders[i];
            if (ctxOrders[0].OrderID == key) {
              __self.orders[i] = newOrders;
              isNewOrder = false;
              break;
            }
          }
          if (isNewOrder) {
            __self.orders.push(newOrders);
          }
        }
      }
    }
  }
  restModel() {
    this.model = {
      PageNo: 0,
      PageSize: 15,
      RecordCount: 15,
      BusinessTypes: [1797, 1789],
      ServiceTypes: [1409, 1407, 1470, 1408],
    };
    return this.model;
  }
  changeStatus(id: string) {
    var model = this.restModel() as any;
    if (id == "waitapproval") {
      model.BusinessTypes = [1797, 1789, 1799];
      model.BusinessStatuss = [10107, 10205];
      model.ActiveUserID = this.profile.UserID;
    } else if (id == "waitpayment") {
      // model.BusinessTypes = [1797, 1789];
      model.BusinessStatuss = [10107];
    } else if (id == "myorder") {
      // model.BusinessTypes = [1797, 1789];
      model.BusinessStatus = "10113";
      model.CreateUserID = this.profile.UserID;
    } else if (id == "recenttrip") {
      model.TaskDate = moment().format("YYYY-MM-DD");
      model.TaskDateEnd = moment()
        .add(30, "days")
        .format("YYYY-MM-DD");
      model.BusinessStatus = "10113";
    }

    model.CreateTime = moment()
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    model.ServiceTypes = [1409, 1407, 1470, 1408];

    this.isCurrentOption = id as any;
    this.pullLoading()
  }

  pullLoading(){
    this.model.PageNo = 0;
    this.finished = false;
    this.loadWorks();
    document.getElementsByClassName("page-body")[0].scrollTop = 0;
  }
  changeLabel(id: number) {
    this.restModel();
    if (id == 0) {
      this.model.ServiceTypes = [1409, 1407, 1470, 1408];
    } else {
      this.model.ServiceTypes = [id];
    }
    this.isCurrentOption = id;
    this.pullLoading();
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  back() {
    history.back();
  }
  gotoDetails(orders: OrderEntity[]) {
    this.$router.push({
      path: "/order/details",
      query: {
        OrderID: orders[0].OrderID,
      },
    });
  }
  onLoad() {
    this.model.PageNo++;
    this.loadWorks();
  }
  call() {
    window.location.href = "tel://400-088-8020";
  }
}
